import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Carousel } from './carousel.model';
import carouselService from './carousel.service';

// namespace
export const CAROUSEL_STORE_NAMESPACE = 'carouselStore';

// state
interface CarouselState {
  carousels: Carousel[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: CarouselState = {
  carousels: [],
  status: 'init',
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<CarouselState> = {
  [mutationConstant.FETCH]: (state: CarouselState, carousels: Carousel[]) => {
    state.carousels = carousels;
  },
  [mutationConstant.PENDING]: (state: CarouselState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: CarouselState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: CarouselState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<CarouselState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<CarouselState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      carouselService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<CarouselState, RootState> = {
  [getterConstant.ALL]: (state: CarouselState) => state.carousels,
  [getterConstant.BY_ID]: (state: CarouselState) => (id: number) => state.carousels.find(m => m.id === id),
  [getterConstant.STATUS]: (state: CarouselState) => state.status,
};

// module
const module: Module<CarouselState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const CarouselGetter = {
  ALL: `${CAROUSEL_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${CAROUSEL_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${CAROUSEL_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const CarouselAction = {
  FETCH: `${CAROUSEL_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
